import { Injectable } from '@angular/core';
import { KeycloakService } from './keycloak.service';
import { URL_ACCESO, URL_BASE, URL_ISSYSMEDIA, URL_Login, URL_session } from '../constantes';
import { entidadGeneral, tipoEntidadGeneral } from '../models/entidadGeneral';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  inicioInstanciaSession = false;
  usuario: string | null = null;
  entidades: entidadGeneral[] = [];
  eg: entidadGeneral|null = null;
  tiposEntidadesDisponibles: entidadGeneral[] = [];
  TIPO_ENTIDAD_SISTEMA = 4

  constructor(private keycloak: KeycloakService,
    private router: Router
  ) {}

  async iniciarApp() {
    //-----console.log("iniciando instancia")
    /** 
     * si se desea cargar una entidad diferente o otros datos debe hacerse en este punto 
     * remplazando la URL_session por una personalizada ej: URL_backen_session
     * de cambiar los datos de sesion revisar que el setCabecera() 
     * tenga el mapeo correcto de los valores de la entidad general
     * */

    /* //-- comento la parte de seisión porque el sistema no lo utiliza, es publico
      if (await this.keycloak.loadAccesTocken()) {
      let sesion = await this.keycloak.get(URL_session).catch(
        error => console.error(error)
      );
      if (sesion && sesion.entidades) {
        this.usuario = sesion.usuario.usuario;
        this.entidades = sesion.entidades;
        let entidadTipo = sesion.entidades.filter((e:entidadGeneral)=>e.codigoTipoEntidadGeneral ==this.TIPO_ENTIDAD_SISTEMA)
        if(entidadTipo.leght == 0) this.cerrarApp('No posee una entidad autorizada para el uso de éste sistema')
        this.eg = entidadTipo[0]
        //cuando no quiero cargar la EG
        //this.setCabecera(sesion.usuario.usuario);
        this.setCabecera(sesion.usuario.usuario,this.eg)
        this.cargarTiposEntidades(sesion.entidades);
        this.router.navigate(['/'])  
      }
    } else {*/
      this.setCabecera()
    //}
    this.inicioInstanciaSession = true;
    //instancia iniciada sin importar si se cargo o no usuario (desactiva loader)
  }

  setCabecera(user: string|null=null, eg: any = null) {
    //------console.log(eg)
    try {
      let head = document.getElementsByTagName("issys-header")[0];
      if(user) head.setAttribute("usuario", user);
      head.setAttribute("tipo_entidad", eg ? eg.tipo : "Bienvenido/a");
      if (eg) {
        head.setAttribute("codigo_entidad", eg.entidadGeneral);
        head.setAttribute("entidad_representada", eg.nombre);
      }

      let s = document.createElement("script");
      s.setAttribute("src", URL_ISSYSMEDIA);
      s.setAttribute("defer", "");
      s.setAttribute("type", "text/javascript");
      const b = document.body;
      b.appendChild(s);

    } catch (e) { console.error(e); }
  }

  cargarTiposEntidades(entidades: entidadGeneral[] = []) {
    console.log(entidades)
    let codigotipos = new Set();
    let tiposEntidades: entidadGeneral[] = [];
    entidades.forEach((e: entidadGeneral) => {
      codigotipos.add(e.codigoTipoEntidadGeneral);
    });
    Object.keys(tipoEntidadGeneral).forEach((k) => {
      if (codigotipos.has(tipoEntidadGeneral[k].codigo)) {
        tiposEntidades.push(tipoEntidadGeneral[k]);
      }
    });
    this.tiposEntidadesDisponibles = [...tiposEntidades];
    console.log(this.tiposEntidadesDisponibles)
  }

  /** recupera la variable de la cabecera y cambia los parámetros necesarios 
   * para que se muestre la nueva entidad con sus notificaciones
   */
  updateCabecera(eg:entidadGeneral){
    try{
      //seteo los valores de la cabecera
      let el = document.getElementById("cabecera-tipo-entidad")
      if(el) el.innerHTML=eg.tipo
      el = document.getElementById("cabecera-entidad-representada")
      if(el) el.innerHTML=eg.nombre
      el = document.getElementById("dropdown-cabecera")
      let el2= el? el.getElementsByClassName("detalle"):null
      if(el2 && el2[0]) el2[0].innerHTML = eg.nombre + " - " + eg.email

      //seteo todos los parámetros para la solicitud de notificaciones
      let usrNot = (<any>window).notificacionesUsr;
      console.log(usrNot)
      if(usrNot){
        usrNot.eg.codigo = eg.entidadGeneral
        usrNot.eg.descripcion = eg.nombre
        usrNot.local.LOCAL_KEY="issys_notificacion_backExt_"+eg.entidadGeneral+"s2"
        usrNot.loadNotificaciones()
      }
    }catch(e){console.error("Error en el seteo de la cabecera",e)}
  }

  cerrarApp(mensaje:string){
    alert(mensaje)
    this.keycloak.desloguear(true)
  }
}
